import React, { FC } from 'react';

import { IntlShape } from 'react-intl';

import { ShortCodeEnums } from '@nhl/nhl-breakaway-ui';
import { TeamDisplay } from '@nhl/nhl-react-ui/lib/TeamDisplay';

import { AwayTeamMatchup, HomeTeamMatchup } from '~/core/customIcons';
import { SpecialEvent } from '~/core/types';
import { parseValueFromLocalizedAttribute } from '~/core/utils';

import { ScheduleGame } from '../../types';
import { formatMessageOverflow } from '../../utils';

import { EventName, TeamContainer, TeamLogoContainer, TeamMatchup, TeamMatchupContainer } from './styles';

type Props = {
    game: ScheduleGame;
    specialEvent?: SpecialEvent;
    intl: IntlShape;
    isCalendarView: boolean;
    allowTruncatedText: boolean;
};

const MESSAGE_CHARACTER_CUTOFF = 23;

const SpecialEventMatchup: FC<Props> = ({ game, specialEvent, intl, isCalendarView, allowTruncatedText }) => {
    const eventName = parseValueFromLocalizedAttribute(specialEvent?.name, intl.locale);
    return (
        <TeamMatchupContainer $isCalendarView={isCalendarView}>
            <EventName>
                {allowTruncatedText ? formatMessageOverflow(MESSAGE_CHARACTER_CUTOFF, eventName) : eventName}
            </EventName>
            <TeamMatchup $isCalendarView={isCalendarView}>
                <TeamContainer $teamAbbrev={game.awayTeam.abbrev} $isHome={false} $isCalendarView={isCalendarView}>
                    <AwayTeamMatchup />
                    <TeamLogoContainer $isCalendarView={isCalendarView}>
                        <TeamDisplay
                            logoUrlOverride={
                                game.awayTeam.abbrev === ShortCodeEnums.TeamTriCode.NSH
                                    ? game.awayTeam.logo
                                    : game.awayTeam.darkLogo
                            }
                            team={{ triCode: game.awayTeam.abbrev }}
                            displayName={false}
                        />
                    </TeamLogoContainer>
                </TeamContainer>
                <TeamContainer $teamAbbrev={game.homeTeam.abbrev} $isHome={true} $isCalendarView={isCalendarView}>
                    <HomeTeamMatchup />
                    <TeamLogoContainer $isCalendarView={isCalendarView}>
                        <TeamDisplay
                            logoUrlOverride={
                                game.homeTeam.abbrev === ShortCodeEnums.TeamTriCode.NSH
                                    ? game.homeTeam.logo
                                    : game.homeTeam.darkLogo
                            }
                            team={{ triCode: game.homeTeam.abbrev }}
                            displayName={false}
                        />
                    </TeamLogoContainer>
                </TeamContainer>
            </TeamMatchup>
        </TeamMatchupContainer>
    );
};

export default SpecialEventMatchup;
